export default __webpack_public_path__ + "static/3-c9957f38c56ad8f5730ffc12ab3d73fb.png";